import { createContext, Dispatch, ReactNode, useContext, useReducer } from "react";
import { ChatInputContextState, chatReducer, ChatInputReducerAction, initialState } from "./reducer";

interface Props {
    reducer: Dispatch<ChatInputReducerAction>;
    state: ChatInputContextState;
    shouldReset?: boolean;
}

const ConversationInputContext = createContext<Props | null>(null)

export const useConversationInputContext = () => {
    const context = useContext(ConversationInputContext)

    if (!context) {
        throw new Error(
            'Component requiring conversation context rendered without a conversation'
        )
    }

    const conversationState: ChatInputContextState = context.state
    const useConversationInputAction: (val: ChatInputReducerAction) => void = context.reducer

    return {
        expandMessage: conversationState.expandMessage,
        shouldReset: context.shouldReset,
        files: conversationState.filesToUpload,
        conversationState,
        useConversationInputAction
    }
}

interface ProviderProps {
    children: ReactNode;
    shouldReset?: boolean
}

const ConversationInputProvider: React.FC<ProviderProps> = ({ children, shouldReset }) => {
    const [state, dispatch] = useReducer(chatReducer, { ...initialState })

    return (
        <ConversationInputContext.Provider value={{ reducer: dispatch, state, shouldReset }}>
            {children}
        </ConversationInputContext.Provider>
    )
}

export default ConversationInputProvider;
